import { render, staticRenderFns } from "./TransferProfessionalReport.vue?vue&type=template&id=a7d6ef32"
import script from "./TransferProfessionalReport.vue?vue&type=script&lang=js"
export * from "./TransferProfessionalReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports